import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent } from '../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { getCurrentTab, getNavList, NavAgentList } from './admin-nav.const';
import { ChatListener } from '../../pages/admin/icontact/chat/chat.listener';

declare var $: any;

@Component({
  selector: 'admin-nav',
  templateUrl: './admin-nav.template.html',
  styleUrls: ['admin-nav.style.css'],
})
export class AdminNavComponent extends BaseComponent {
  @Input() type: string;
  data: any;
  public nav: string;
  public navList: any = [];
  isOpen = false;
  public unread_chat = 0;
  public offline_chat = 0;
  protected readonly NavAgentList = NavAgentList;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private router: Router,
    private chatListener: ChatListener
  ) {
    super(changeDetector, toastr, modalService);
    this.navList = getNavList(this.user);
    this.nav = getCurrentTab(this.router.url, this.user);
    this.chatListener.countUnreadChat.subscribe(res => {
      const { unreadMessage, offlineChannel } = res;
      this.unread_chat = unreadMessage;
      this.offline_chat = offlineChannel;
    });
    this.chatListener.onOpenChat.subscribe(() => {
      if (!this.router.url.includes('chatting')) {
        this.router.navigate(['/chatting']);
      } else {
        this.chatListener.chatOpened = {
          channel: 'unread',
          data: {},
        };
      }
      this.nav = getCurrentTab('/chatting/all', this.user);
    });
  }

  on_click(url) {
    $('.main-content').css('display', 'block');
    $('.tab-content').css('display', 'none');
    this.nav = url;
    this.router.navigate([url]);
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/navigation/admin-nav.component.ts